<div class="image-cropping">
  <div class="image-cropping__container">
    <canvas [class.w100]="canvasWidth100Percent" #canvasElement></canvas>
  </div>
  <div class="image-cropping__tools">
    <div class="image-cropping__range" *ngIf="editingEnabled">
      <button
        class="image-cropping__range__btn"
        (click)="changeImageScale(imageScale - imageScaleStep)"
      >
        <ui-svg-icon
          svgId="minus"
          iconClassName="icon-shared--minus"
        ></ui-svg-icon>
      </button>
      <input
        type="range"
        [min]="imageScaleMin"
        [max]="imageScaleMax"
        [step]="imageScaleStep"
        [ngModel]="imageScale"
        #range
        (ngModelChange)="changeImageScale(+range.value)"
      />

      <button
        class="image-cropping__range__btn"
        (click)="changeImageScale(imageScale + imageScaleStep)"
      >
        <ui-svg-icon
          svgId="plus"
          iconClassName="icon-shared--plus"
        ></ui-svg-icon>
      </button>
    </div>
    <div class="image-cropping__rotation" *ngIf="editingEnabled">
      <button class="image-cropping__rotation__btn" (click)="rotateMainImage()">
        <ui-svg-icon
          svgId="rotate"
          iconClassName="icon-shared--minus"
        ></ui-svg-icon>
        Rotate
      </button>
    </div>
  </div>
</div>
